import React from 'react';
import { useIntl } from 'react-intl';

// helpers
import { boundLengthManualFormatter } from '../../../../../../../../formatters';
import { UserRoles } from '../../../../../../../../constraints';

// Components
import { ProtectedComponent } from '../../../../../../../Auth/components';
import { ControlledTextFieldNotStyled } from '../../../../../../../../components/ControlledTextFieldNotStyled/ControlledTextFieldNotStyled';
import EditButton from '../EditButton';

const EditEmailTitleButton = ({
  isEditActive,
  emailTitleFieldName,
  handleActive,
  contentValue,
  disabled,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {!isEditActive && boundLengthManualFormatter(contentValue, 80)}
      {!isEditActive && !contentValue && '---'}
      {isEditActive && (
        <ControlledTextFieldNotStyled
          name={emailTitleFieldName}
          placeholder={formatMessage({
            id: 'Enter Subject content',
            defaultMessage: 'Enter Subject content',
          })}
          disabled={disabled}
        />
      )}
      {!isEditActive && (
        <ProtectedComponent
          roles={[UserRoles.BUSINESS_ADMIN, UserRoles.ADMIN]}
          render={false}
        >
          <EditButton handleActive={handleActive} name={emailTitleFieldName} />
        </ProtectedComponent>
      )}
    </>
  );
};

export default EditEmailTitleButton;
